import { GeoLocation as WeldLocation, Weld, CommodityAssignee, UpdateCommodityLocationDescriptionError } from '@bechtel/types';
import { ApolloError } from '@apollo/client';

export type UpdateCommodityLocationDescriptionErrorExt = UpdateCommodityLocationDescriptionError | ApolloError;

export interface UpdateCommodityLocationDescriptionErrorProps {
  error: UpdateCommodityLocationDescriptionErrorExt;
  close: () => void;
}

export interface WeldLocationProps {
  weldId: Weld['id'];
  location?: WeldLocation | null;
  locationDescription?: string;
  commodityAssignees?:CommodityAssignee[]
}

export interface WeldLocationDescriptionFormikState {
  locationDesc?: string;
}
